import React from 'react';
import logo from '../assets/images/tg_logo.png';

function TopBar() {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        width: '100%',
        height: '90px',
        backgroundColor: '#f1f5f6',
        color: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.3)',
        zIndex: 1000
      }}>
        <img src={logo} alt="Logo" style={{ height: '60px'}} />
      </div>
    );
  }

export default TopBar;
